__turbopack_context__.v({
  "arrowIcon": "LanguagePicker-module__4ulGpq__arrowIcon",
  "button": "LanguagePicker-module__4ulGpq__button",
  "checkmark": "LanguagePicker-module__4ulGpq__checkmark",
  "closeButton": "LanguagePicker-module__4ulGpq__closeButton",
  "fadeIn": "LanguagePicker-module__4ulGpq__fadeIn",
  "flagIcon": "LanguagePicker-module__4ulGpq__flagIcon",
  "full": "LanguagePicker-module__4ulGpq__full",
  "labelFull": "LanguagePicker-module__4ulGpq__labelFull",
  "labelShort": "LanguagePicker-module__4ulGpq__labelShort",
  "languageCode": "LanguagePicker-module__4ulGpq__languageCode",
  "languageGrid": "LanguagePicker-module__4ulGpq__languageGrid",
  "languageInfo": "LanguagePicker-module__4ulGpq__languageInfo",
  "languageName": "LanguagePicker-module__4ulGpq__languageName",
  "languageOption": "LanguagePicker-module__4ulGpq__languageOption",
  "modal": "LanguagePicker-module__4ulGpq__modal",
  "modalHeader": "LanguagePicker-module__4ulGpq__modalHeader",
  "modalTitle": "LanguagePicker-module__4ulGpq__modalTitle",
  "overlay": "LanguagePicker-module__4ulGpq__overlay",
  "selected": "LanguagePicker-module__4ulGpq__selected",
  "selectedName": "LanguagePicker-module__4ulGpq__selectedName",
  "slideUp": "LanguagePicker-module__4ulGpq__slideUp",
  "slideUpMobile": "LanguagePicker-module__4ulGpq__slideUpMobile",
  "wrapper": "LanguagePicker-module__4ulGpq__wrapper",
});
